import React, {FC, useEffect} from "react"
import {ClassicCard} from "@irati/braze/services/sdk"
import tracking from "@irati-tracking/content-cards"
import PropTypes from "prop-types"
import ClassicContentCard from "../ClassicContentCard"
import {CardsContainer, CardsWrapper, ContainerShadow, StyledHr} from "./styled"
import EmptyCardsContainer from "./EmptyCardsContainer"

interface Props {
  cards: ClassicCard[]
}

interface Context {
  apps: {[key: string]: string},
  appPath: string
}

const ContentCardsContainer: FC<Props> = ({cards}, context: Context) => {

  useEffect(() => {
    const {appPath, apps: contextApps} = context
    const {ADMIN} = contextApps

    tracking.viewContentCards({source: appPath === ADMIN ? "admin" : "user"})
  }, [])

  const getContent = () => {
    return cards
      .filter((card) => !card.dismissed)
      .sort((c1, c2) => {
        if (c1.pinned && c2.pinned) {
          return c1.created?.getTime() < c2.created?.getTime() ? -1 : 1
        }
        return c1.pinned ? -1 : 1
      }).map((card, index) => (
        <div key={card.id}>
          <ClassicContentCard card={card} />
          {index !== cards.length - 1 && <StyledHr flush />}
        </div>)
      )
  }

  return cards.length ?
    <CardsContainer>
      <CardsWrapper>
        {getContent()}
        <ContainerShadow />
      </CardsWrapper>
    </CardsContainer> : <EmptyCardsContainer />

}

ContentCardsContainer.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default ContentCardsContainer
